/* Temperato — lo justo para las secciones de la portada.
   Sin dependencias: Dawn ya carga bastante JavaScript. */
(() => {
  'use strict';

  /* Carrusel de sabores. Las flechas avanzan una pantalla, no dos tarjetas:
     con 36 sabores, de dos en dos son más de treinta clics. Se deshabilitan al
     llegar al final para que se vea que se ha recorrido todo. */
  document.querySelectorAll('[data-tmp-carrusel]').forEach((caja) => {
    const pista = caja.querySelector('[data-tmp-pista]');
    const izq = caja.querySelector('[data-tmp-izq]');
    const der = caja.querySelector('[data-tmp-der]');
    if (!pista || !izq || !der) return;

    const paso = () => Math.max(200, Math.round(pista.clientWidth * 0.9));
    const refrescar = () => {
      const max = pista.scrollWidth - pista.clientWidth - 2;
      izq.disabled = pista.scrollLeft <= 2;
      der.disabled = pista.scrollLeft >= max;
    };
    izq.addEventListener('click', () => pista.scrollBy({ left: -paso(), behavior: 'smooth' }));
    der.addEventListener('click', () => pista.scrollBy({ left: paso(), behavior: 'smooth' }));
    pista.addEventListener('scroll', refrescar, { passive: true });
    addEventListener('resize', refrescar);
    refrescar();
  });

  /* Aparición al bajar. El contenido nunca depende de la animación: si el
     sistema pide menos movimiento o no hay IntersectionObserver, todo queda
     visible de entrada. */
  /* Las tarjetas de gelatería aparecen una a una, así que su sección no se
     revela entera: si lo hiciera, el escalonado quedaría escondido dentro de
     un fundido que ya ha terminado.

     La función se expone en `window` porque en el editor de Shopify una sección
     se vuelve a pintar sola al editarla (`shopify:section:load`) y su contenido
     nace sin observar: sin volver a llamar aquí, esa sección se quedaría
     invisible dentro del editor. Se marca lo ya observado para no observar dos
     veces la misma pieza. */
  const SELECTOR = '.tmp-seccion:not(.tmp-capa-gelaterias .tmp-seccion), .tmp-hero, .tmp-local';
  let vigia = null;

  function revelar(raiz) {
    const piezas = (raiz || document).querySelectorAll(SELECTOR);
    if (!piezas.length) return;
    const quieto = matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (quieto || !('IntersectionObserver' in window)) {
      piezas.forEach((p) => p.classList.add('tmp-visible'));
      return;
    }
    if (!vigia) {
      vigia = new IntersectionObserver((entradas) => {
        entradas.forEach((e) => {
          if (e.isIntersecting) { e.target.classList.add('tmp-visible'); vigia.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.04 });
    }
    piezas.forEach((p) => {
      if (p.dataset.tmpVigilada) return;
      p.dataset.tmpVigilada = '1';
      p.classList.add('tmp-aparece');
      vigia.observe(p);
    });
  }

  window.tmpRevelar = revelar;
  revelar(document);

  /* En el editor, la sección recién pintada se revela sola. */
  document.addEventListener('shopify:section:load', (e) => revelar(e.target));
})();

/* Filtros de la carta de sabores.
   Esconden y muestran, no reordenan: si al filtrar cambia el orden, quien
   estaba leyendo pierde el sitio. La cuenta de arriba se actualiza sola. */
(function () {
  document.querySelectorAll('[data-tmp-filtros]').forEach(function (barra) {
    var seccion = barra.closest('.shopify-section') || document;
    var carta = seccion.querySelector('[data-tmp-carta]');
    var cuenta = seccion.querySelector('[data-tmp-cuenta]');
    var vacio = seccion.querySelector('[data-tmp-vacio]');
    if (!carta) return;
    var sabores = Array.prototype.slice.call(carta.children);

    function filtrar(dieta) {
      var vistos = 0;
      sabores.forEach(function (li) {
        var dietas = (li.dataset.dietas || '').split(',').map(function (d) { return d.trim(); });
        var cabe = !dieta || dietas.indexOf(dieta) !== -1;
        li.hidden = !cabe;
        if (cabe) vistos++;
      });
      if (cuenta) cuenta.textContent = vistos + (vistos === 1 ? ' sabor' : ' sabores');
      if (vacio) vacio.hidden = vistos > 0;
      barra.querySelectorAll('[data-tmp-dieta]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.tmpDieta === dieta));
      });
    }

    barra.addEventListener('click', function (e) {
      var boton = e.target.closest('[data-tmp-dieta]');
      if (boton) filtrar(boton.dataset.tmpDieta);
    });
  });
})();

/* Vitrina de sabores — anillo virtual.

   Todos los sabores están en el DOM y cada uno tiene SIEMPRE una posición. Lo
   único que cambia al avanzar es la transformación de cada tarjeta, así que
   ninguna aparece de golpe: la que entra viene del fondo derecho, la de la
   derecha viaja al centro y la del centro se va a la izquierda encogiendo.

   Qué provocaba el salto de la primera versión: había tres huecos y se les
   cambiaba la imagen. La tarjeta que entraba no venía de ninguna parte, se
   pintaba ya colocada, y el navegador no tenía un estado anterior desde el que
   animarla.

   Índice virtual: no se reinicia al llegar al último. De cada tarjeta se busca
   la copia del anillo más cercana al índice activo, así que del último al
   primero se pasa por el camino corto y sin salto.  */
(function () {
  var CURVA = 750;                 // debe coincidir con la transición del CSS
  var UMBRAL = 0.26;               // cuánto hay que arrastrar para que pase

  document.querySelectorAll('[data-tmp-vitrina]').forEach(function (raiz) {
    var escena = raiz.querySelector('[data-tmp-escena]');
    var bandejas = Array.prototype.slice.call(raiz.querySelectorAll('[data-tmp-bandeja]'));
    var total = bandejas.length;
    if (!escena || total < 2) return;

    var posicion = raiz.querySelector('[data-tmp-posicion]');
    var quieto = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var actual = parseInt(raiz.dataset.inicio, 10) || 0;
    var moviendo = false;
    var reloj = null;
    var intervalo = (parseInt(raiz.dataset.autoplay, 10) || 0) * 1000;

    function num(nombre, porDefecto) {
      var v = parseFloat(getComputedStyle(raiz).getPropertyValue(nombre));
      return isNaN(v) ? porDefecto : v;
    }

    /* Cuánto se separan dos posiciones del anillo. Sale del ancho de
       maquetación de la bandeja, así que acompaña al tamaño de cada pantalla.

       `offsetWidth` y no `getBoundingClientRect()`: el segundo devuelve la caja
       YA transformada, y como las bandejas van escaladas, la separación cambiaba
       en cada fotograma del movimiento. Eso hacía que las posiciones bailaran
       mientras se arrastraba. */
    function separacion() {
      var ancho = bandejas[0].offsetWidth;
      if (!ancho) ancho = escena.offsetWidth * 0.3;
      return ancho * 0.74;
    }

    function entre(a, b, t) { return a + (b - a) * t; }

    /* La posición de una tarjeta es una función continua de su distancia al
       centro, no una tabla de tres casos. Por eso vale igual para un arrastre a
       medias: con desplazamiento 0,4 la tarjeta está a cuatro décimas de camino. */
    function colocar(bandeja, off, sep) {
      var d = Math.abs(off);
      var cerca = Math.min(d, 1);          // 0 en el centro, 1 en los lados

      var escalaActiva = num('--v-activa-escala', 1.08);
      var escalaLado = num('--v-lado-escala', 0.76);
      var giroLado = num('--v-lado-giro', 14);
      var bajaLado = num('--v-lado-baja', 90);
      var prof = num('--v-perspectiva', 1600);

      /* Mas alla de la posicion lateral la bandeja NO sigue encogiendo.
         Antes cada paso del anillo restaba un 6 % de escala y 90 px de
         profundidad, asi que la que entraba por la derecha aparecia a 218 px
         —ya visible, con opacidad 0,13— y crecia hasta 240 mientras se veia:
         un 10 % de cambio de tamano con la foto delante. Eso es el «salto de
         tamano al rotar» que senalo la clienta. Ahora las de detras estan a la
         misma escala y a la misma profundidad que la lateral, y lo unico que
         cambia es la posicion horizontal y la transparencia: la que entra
         aparece YA a su tamano final. */
      var escala = entre(escalaActiva, escalaLado, cerca);
      var x = off * sep;
      var y = bajaLado * cerca;
      /* La activa se queda en z = 0 a proposito. Con `perspective: 1600px`, un
       `translateZ(110px)` amplia por 1600 / (1600 - 110) = 1,074, así que la
       bandeja del centro se pintaba un 7 % más grande de su caja ADEMÁS de la
       escala: 1,08 × 1,074 = 1,16. Eso es el zoom que la clienta señaló, y es lo
       que hacía que la foto se viera blanda justo en el sitio donde más se mira,
       y que diera un salto de nitidez al llegar. Ahora la del centro se pinta a
       su tamaño exacto y las que encogen son las de los lados. */
      var z = entre(0, -180, cerca);
      /* El giro se topa en la posicion lateral, no en 1,6. Un `rotateY` mayor
         estrecha la caja proyectada —a 22,4 grados un 5 % mas que a 14—, asi que
         dejarlo crecer detras devolvia por otra via el mismo cambio de tamano al
         entrar. Mas alla del lateral solo cambian la posicion y la opacidad. */
      var giro = -giroLado * Math.max(-1, Math.min(1, off));
      var opacidad = d <= 1 ? 1 : Math.max(0, 1 - (d - 1));

      /* La tarjeta solo se mueve en horizontal; la foto es la que se escala,
         gira y se hunde. Así el nombre no sube, ni baja, ni se empequeñece con
         la profundidad. */
      bandeja.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
      bandeja.style.opacity = opacidad.toFixed(3);
      bandeja.style.zIndex = String(100 - Math.round(d * 10));
      var hueco = bandeja.querySelector('[data-tmp-hueco]');
      if (hueco) {
        /* La perspectiva va AQUI, en cada bandeja, y no en el escenario. Con una
           perspectiva compartida el punto de fuga es fijo, asi que la proyeccion
           de una bandeja depende de lo lejos que este de el: con la misma escala,
           la misma profundidad y el mismo giro, la de la posicion 2 se pintaba un
           3,8 % mas ancha que la de la 1, y ese resto se veia justo al entrar por
           la derecha. Da igual quitar la profundidad: lo que crea el desnivel es
           el propio `rotateY`, que saca las dos mitades de la bandeja a
           profundidades distintas. Con la perspectiva en el elemento, su punto de
           fuga viaja con ella y el ancho ya no depende de donde este. */
        hueco.style.transform =
          'perspective(' + prof + 'px)' +
          ' translate3d(0,' + y.toFixed(2) + 'px,' + z.toFixed(2) + 'px)' +
          ' rotateY(' + giro.toFixed(2) + 'deg)' +
          ' scale(' + escala.toFixed(4) + ')';
      }
    }

    /* Todas las posiciones se escriben en el MISMO fotograma: si se reparten en
       varios, unas tarjetas van una vuelta por delante de otras. */
    function pintar(centro) {
      var sep = separacion();
      requestAnimationFrame(function () {
        for (var i = 0; i < total; i++) {
          var b = bandejas[i];
          var virtual = i + Math.round((centro - i) / total) * total;
          var off = virtual - centro;
          colocar(b, off, sep);
          var esActiva = Math.abs(off) < 0.5;
          b.classList.toggle('tmp-bandeja--activa', esActiva);
          /* Lo que no se ve no se tabula. No se usa `display` ni
             `visibility`: la tarjeta tiene que poder animarse igual. */
          if ('inert' in b) b.inert = !esActiva;
          b.setAttribute('aria-hidden', esActiva ? 'false' : 'true');
        }
      });
      if (posicion) {
        var n = ((Math.round(centro) % total) + total) % total + 1;
        posicion.textContent = (n < 10 ? '0' : '') + n;
      }
    }

    function mover(paso) {
      if (moviendo) return;              // clics repetidos: se ignoran
      moviendo = true;
      actual = ((actual + paso) % total + total) % total;
      pintar(actual);
      /* El autoplay se rearma YA, no al terminar la transición: si espera, se
         nota una pausa entre movimientos. */
      arrancar();
      var activa = bandejas[actual];
      var soltar = function () { moviendo = false; };
      var vigilante = setTimeout(soltar, CURVA + 60);
      activa.addEventListener('transitionend', function fin(e) {
        if (e.propertyName !== 'transform') return;
        activa.removeEventListener('transitionend', fin);
        clearTimeout(vigilante);
        soltar();
      });
    }

    function arrancar() {
      parar();
      if (!intervalo || quieto) return;
      reloj = setTimeout(function () { mover(1); }, intervalo);
    }
    function parar() { if (reloj) { clearTimeout(reloj); reloj = null; } }

    var antes = raiz.querySelector('[data-tmp-antes]');
    var despues = raiz.querySelector('[data-tmp-despues]');
    if (antes) antes.addEventListener('click', function () { mover(-1); });
    if (despues) despues.addEventListener('click', function () { mover(1); });

    raiz.addEventListener('mouseenter', parar);
    raiz.addEventListener('mouseleave', arrancar);
    raiz.addEventListener('focusin', parar);

    raiz.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { parar(); mover(-1); }
      if (e.key === 'ArrowRight') { parar(); mover(1); }
    });

    /* Arrastre. El movimiento sigue al dedo desde el primer píxel: convertir el
       desplazamiento en fracción de índice es lo que evita que se quede quieto
       hasta soltar. */
    var arrastre = null;
    /* El arrastre nativo de imágenes y enlaces se desactiva: si arranca, el
       navegador manda `pointercancel` y nuestro gesto se corta a los dos
       fotogramas. */
    escena.addEventListener('dragstart', function (e) { e.preventDefault(); });
    escena.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      arrastre = { x: e.clientX, y: e.clientY, sep: separacion(), frac: 0, activo: false };
      parar();
    });
    escena.addEventListener('pointermove', function (e) {
      if (!arrastre) return;
      var dx = e.clientX - arrastre.x;
      var dy = e.clientY - arrastre.y;
      if (!arrastre.activo) {
        if (Math.abs(dx) < 6 || Math.abs(dx) < Math.abs(dy)) return;  // es un scroll vertical
        arrastre.activo = true;
        raiz.classList.add('tmp-vitrina--arrastrando');
        escena.setPointerCapture && escena.setPointerCapture(e.pointerId);
      }
      arrastre.frac = -dx / arrastre.sep;
      pintar(actual + arrastre.frac);
    });

    function terminarArrastre() {
      if (!arrastre) return;
      var frac = arrastre.activo ? arrastre.frac : 0;
      var iba = arrastre.activo;
      arrastre = null;
      if (!iba) { arrancar(); return; }
      /* Se devuelve la transición ANTES de pintar el destino, y el destino se
         pinta en el fotograma siguiente: si se hacen las dos cosas en el mismo
         fotograma el navegador las junta y no hay animación, hay salto. */
      raiz.classList.remove('tmp-vitrina--arrastrando');
      void escena.offsetWidth;                       // se fuerza a leer el estado actual
      requestAnimationFrame(function () {
        if (Math.abs(frac) > UMBRAL) mover(frac > 0 ? 1 : -1);
        else { pintar(actual); arrancar(); }
      });
    }
    escena.addEventListener('pointerup', terminarArrastre);
    escena.addEventListener('pointercancel', terminarArrastre);
    escena.addEventListener('pointerleave', function () { if (arrastre && !arrastre.activo) terminarArrastre(); });

    /* Un clic sobre una lateral la trae al centro; sobre la activa, deja pasar
       al enlace. */
    escena.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tmp-bandeja]');
      if (!b || b.classList.contains('tmp-bandeja--activa')) return;
      e.preventDefault();
      var i = parseInt(b.dataset.indice, 10);
      var virtual = i + Math.round((actual - i) / total) * total;
      mover(virtual - actual);
    });

    /* Se decodifican la activa, la anterior, la siguiente y la de detrás antes
       de que empiece a pasar solo: una imagen sin decodificar es un parón. */
    function preparar() {
      var idx = [0, -1, 1, 2].map(function (d) { return ((actual + d) % total + total) % total; });
      var esperas = idx.map(function (i) {
        var img = bandejas[i].querySelector('img');
        if (!img) return Promise.resolve();
        if (img.decode) return img.decode().catch(function () {});
        return img.complete ? Promise.resolve() : new Promise(function (ok) {
          img.addEventListener('load', ok, { once: true });
          img.addEventListener('error', ok, { once: true });
        });
      });
      Promise.all(esperas).then(arrancar);
    }

    pintar(actual);
    preparar();
    addEventListener('resize', function () { pintar(actual); });
  });
})();

/* Cajón del menú. Es un <details>, así que abre y cierra sin JavaScript; esto
   solo añade lo que un <details> no trae: que se cierre al pulsar fuera y con
   la tecla de escape, que es lo que espera cualquiera que lo abra. */
(function () {
  document.querySelectorAll('.tmp-cajon').forEach(function (cajon) {
    var capa = cajon.querySelector('.tmp-cajon__capa');
    if (capa) {
      capa.addEventListener('click', function (e) {
        // Solo si se pulsa el velo, no el panel.
        if (e.target === capa) cajon.open = false;
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cajon.open) cajon.open = false;
    });
  });
})();

/* Selector de presentación y de diseño de lata en la ficha.

   Dos pasos, que es como se decide: primero si quiero la lata, después de qué
   color. El grupo de diseños solo aparece si se ha elegido «con lata», y la
   lata elegida se ve grande — es una pieza ilustrada y hay que poder mirarla.

   Sin JavaScript se ve el primer paso y las tres latas: se pierde el cambio de
   la lata grande, no la información. */
(function () {
  document.querySelectorAll('[data-tmp-presentacion]').forEach(function (grupo) {
    var forma = grupo.closest('form');
    if (!forma) return;
    var grupoLatas = forma.querySelector('[data-tmp-grupo-latas]');
    var campoId = forma.querySelector('[data-tmp-id]');
    var elegido = grupo.querySelector('[data-tmp-elegido]');
    var grande = forma.querySelector('[data-tmp-lata-grande]');
    var fotoGrande = forma.querySelector('[data-tmp-lata-foto]');
    var pieGrande = forma.querySelector('[data-tmp-lata-pie]');

    function latasDisponibles() {
      return Array.prototype.slice.call(forma.querySelectorAll('input[name="lata"]:not([disabled])'));
    }

    function refrescar() {
      var conLata = forma.querySelector('input[name="presentacion"][value="con"]');
      var lleva = !!(conLata && conLata.checked);
      if (grupoLatas) grupoLatas.hidden = !lleva;

      var lata = forma.querySelector('input[name="lata"]:checked:not([disabled])');
      if (lleva && !lata) {
        /* Si la que estaba marcada se ha agotado, se pasa a la primera que
           quede: dejar marcada una agotada manda al carrito algo que no hay. */
        lata = latasDisponibles()[0];
        if (lata) lata.checked = true;
      }

      var sin = forma.querySelector('input[name="presentacion"][value="sin"]');
      if (campoId) {
        campoId.value = lleva && lata ? lata.value : (sin ? sin.dataset.id : campoId.value);
      }
      /* Los rótulos vienen del marcado, que es lo que pasa por las claves de
         idioma: escritos aquí se quedaban en español en la tienda inglesa.
         `data-color` sigue siendo el dato —decide el archivo— y `data-nombre`
         es lo que se lee. */
      var grupoPres = forma.querySelector('[data-tmp-presentacion]');
      var rotConLata = grupoPres ? grupoPres.dataset.rotuloCon : '';
      var rotSinLata = grupoPres ? grupoPres.dataset.rotuloSin : '';
      if (elegido) {
        var nombre = lata ? (lata.dataset.nombre || '') : '';
        elegido.textContent = lleva
          ? rotConLata + (nombre ? ' · ' + nombre : '')
          : rotSinLata;
      }
      if (lleva && lata && fotoGrande && lata.dataset.foto) {
        fotoGrande.src = lata.dataset.foto;
        var patron = grande && grande.dataset.altPatron ? grande.dataset.altPatron : '';
        if (patron) fotoGrande.alt = patron.replace('__COLOR__', lata.dataset.nombre || '');
      }
      if (pieGrande && lata) {
        pieGrande.textContent = lata.dataset.nombre || '';
      }
    }

    forma.addEventListener('change', function (e) {
      if (e.target.name === 'presentacion' || e.target.name === 'lata') refrescar();
    });
    /* Elegir un diseño da por hecho que se quiere la lata. */
    forma.querySelectorAll('input[name="lata"]').forEach(function (r) {
      r.addEventListener('change', function () {
        var con = forma.querySelector('input[name="presentacion"][value="con"]');
        if (con) con.checked = true;
        refrescar();
      });
    });
    refrescar();
  });
})();

/* --------------------------------------------------------------------------
   Carrito: el paso de cantidad.

   Los dos botones cambian el número y envían el formulario, que es lo que
   Shopify espera (`updates[]` + `name="update"`). Sin JavaScript sigue
   funcionando: el campo se escribe a mano y se pulsa «Actualizar el carrito».

   Poner la cantidad a 0 quita la línea, que es el comportamiento propio de
   Shopify, así que el menos no se topa en 1.
   -------------------------------------------------------------------------- */
(function () {
  var forma = document.querySelector('[data-tmp-carrito]');
  if (!forma) return;

  forma.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-tmp-paso]');
    if (!boton) return;
    var caja = boton.closest('[data-tmp-cantidad]');
    var campo = caja && caja.querySelector('input[name="updates[]"]');
    if (!campo) return;
    var valor = parseInt(campo.value, 10);
    if (isNaN(valor)) valor = 1;
    valor += parseInt(boton.dataset.tmpPaso, 10);
    if (valor < 0) valor = 0;
    campo.value = valor;
    forma.requestSubmit
      ? forma.requestSubmit(forma.querySelector('[name="update"]'))
      : forma.submit();
  });
})();

/* --------------------------------------------------------------------------
   Gelaterías: estado abierto/cerrado y filtros.

   El estado se calcula AQUÍ y no en Liquid a propósito. Las páginas se sirven
   desde la CDN de Shopify, así que un «abierto ahora» escrito en el HTML sale
   caducado: diría lo que era verdad cuando se generó la página, no ahora.

   Y se calcula siempre en la hora de **Europe/Madrid**, que es la del negocio.
   Si se usara la hora del visitante, alguien mirando desde Londres o desde
   México vería la gelatería cerrada estando abierta.

   Sin horario no se afirma nada: el indicador se queda escondido. Un «abierto»
   inventado hace que alguien se plante en la puerta con la persiana bajada.

   El formato es el mismo que `regularHours` / `specialHours` de Google Business
   Profile, para que una sincronización futura escriba en estos mismos campos
   sin tocar ni el diseño ni este cálculo.
   -------------------------------------------------------------------------- */
(function () {
  var zona = document.querySelector('[data-tmp-locales]');
  if (!zona) return;

  var DIAS = ['lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo'];

  /* Ahora mismo en Madrid: fecha, minutos del día y día de la semana 1..7. */
  function ahoraEnMadrid() {
    var partes;
    try {
      partes = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hour12: false
      }).formatToParts(new Date());
    } catch (e) {
      return null;                       /* navegador sin husos: no se afirma nada */
    }
    var o = {};
    partes.forEach(function (x) { o[x.type] = x.value; });
    var hora = o.hour === '24' ? '00' : o.hour;
    var fecha = o.year + '-' + o.month + '-' + o.day;
    var semana = new Date(fecha + 'T00:00:00Z').getUTCDay();   /* 0 = domingo */
    return {
      fecha: fecha,
      mesdia: o.month + '-' + o.day,
      minutos: parseInt(hora, 10) * 60 + parseInt(o.minute, 10),
      dia: semana === 0 ? 7 : semana
    };
  }

  function aMinutos(hhmm) {
    var t = /^(\d{1,2}):(\d{2})$/.exec(hhmm.trim());
    if (!t) return null;
    return parseInt(t[1], 10) * 60 + parseInt(t[2], 10);
  }

  /* «1-5», «6,7» o «3» -> [1,2,3,4,5] */
  function diasDe(spec) {
    var salida = [];
    spec.split(',').forEach(function (trozo) {
      trozo = trozo.trim();
      if (trozo.indexOf('-') > 0) {
        var a = parseInt(trozo.split('-')[0], 10), b = parseInt(trozo.split('-')[1], 10);
        if (!a || !b) return;
        if (a <= b) { for (var d = a; d <= b; d++) salida.push(d); }
        else { for (var e = a; e <= 7; e++) salida.push(e); for (var f = 1; f <= b; f++) salida.push(f); }
      } else {
        var n = parseInt(trozo, 10);
        if (n >= 1 && n <= 7) salida.push(n);
      }
    });
    return salida;
  }

  /* Texto del horario -> { 1: [[inicio, fin], …], … } */
  function leerSemana(texto) {
    var semana = {};
    (texto || '').split('\n').forEach(function (linea) {
      var trozos = linea.trim().split(/\s+/).filter(Boolean);
      if (trozos.length < 2) return;
      var dias = diasDe(trozos[0]);
      var tramos = [];
      trozos.slice(1).forEach(function (t) {
        var p = t.split('-');
        if (p.length !== 2) return;
        var a = aMinutos(p[0]), b = aMinutos(p[1]);
        if (a === null || b === null) return;
        tramos.push([a, b]);
      });
      dias.forEach(function (d) { semana[d] = (semana[d] || []).concat(tramos); });
    });
    return semana;
  }

  /* «2026-12-25 cerrado» | «2026-12-24 13:00-18:00» */
  function leerEspeciales(texto) {
    var mapa = {};
    (texto || '').split('\n').forEach(function (linea) {
      var trozos = linea.trim().split(/\s+/).filter(Boolean);
      if (!trozos.length) return;
      if (!/^\d{4}-\d{2}-\d{2}$/.test(trozos[0])) return;
      var tramos = [];
      trozos.slice(1).forEach(function (t) {
        if (/cerrad/i.test(t)) return;
        var p = t.split('-');
        if (p.length !== 2) return;
        var a = aMinutos(p[0]), b = aMinutos(p[1]);
        if (a !== null && b !== null) tramos.push([a, b]);
      });
      mapa[trozos[0]] = tramos;        /* lista vacía = cerrado ese día */
    });
    return mapa;
  }

  /* MM-DD dentro del rango, con vuelta de año («11-01» a «03-15»). */
  function enTemporada(mesdia, desde, hasta) {
    if (!desde || !hasta) return true;
    if (desde <= hasta) return mesdia >= desde && mesdia <= hasta;
    return mesdia >= desde || mesdia <= hasta;
  }

  function dosCifras(n) { return n < 10 ? '0' + n : String(n); }
  function comoHora(min) { return dosCifras(Math.floor(min / 60) % 24) + ':' + dosCifras(min % 60); }

  var ahora = ahoraEnMadrid();
  var hayEstado = false;

  Array.prototype.forEach.call(zona.querySelectorAll('[data-tmp-local]'), function (tarjeta) {
    var caja = tarjeta.querySelector('[data-tmp-estado]');
    var texto = tarjeta.querySelector('[data-tmp-estado-texto]');
    var horas = tarjeta.dataset.horas || '';
    if (!caja || !texto || !ahora || !horas.trim()) return;

    var semana = leerSemana(horas);
    var especiales = leerEspeciales(tarjeta.dataset.especiales || '');
    var fuera = !enTemporada(ahora.mesdia, (tarjeta.dataset.temporadaDesde || '').trim(),
                                           (tarjeta.dataset.temporadaHasta || '').trim());

    function tramosDe(dia, fecha) {
      if (fecha && Object.prototype.hasOwnProperty.call(especiales, fecha)) return especiales[fecha];
      return semana[dia] || [];
    }

    var abierta = false, cierraA = null;
    if (!fuera) {
      tramosDe(ahora.dia, ahora.fecha).forEach(function (t) {
        var fin = t[1] <= t[0] ? t[1] + 1440 : t[1];      /* tramo que pasa de medianoche */
        if (ahora.minutos >= t[0] && ahora.minutos < fin) { abierta = true; cierraA = t[1]; }
      });
      /* Un tramo de ayer que cruza la medianoche todavía cuenta. */
      if (!abierta) {
        var ayer = ahora.dia === 1 ? 7 : ahora.dia - 1;
        tramosDe(ayer, null).forEach(function (t) {
          if (t[1] <= t[0] && ahora.minutos < t[1]) { abierta = true; cierraA = t[1]; }
        });
      }
    }

    var frase;
    if (fuera) {
      frase = 'Cerrado por temporada';
    } else if (abierta) {
      frase = 'Abierto ahora' + (cierraA !== null ? ' · cierra a las ' + comoHora(cierraA) : '');
    } else {
      /* El próximo tramo, buscando hasta siete días por delante. */
      var proximo = null;
      for (var salto = 0; salto <= 7 && !proximo; salto++) {
        var dia = ((ahora.dia - 1 + salto) % 7) + 1;
        var tramos = tramosDe(dia, salto === 0 ? ahora.fecha : null).slice().sort(function (a, b) { return a[0] - b[0]; });
        for (var i = 0; i < tramos.length; i++) {
          if (salto > 0 || tramos[i][0] > ahora.minutos) {
            proximo = { salto: salto, dia: dia, hora: tramos[i][0] };
            break;
          }
        }
      }
      if (!proximo) frase = 'Cerrado';
      else if (proximo.salto === 0) frase = 'Cerrado · abre a las ' + comoHora(proximo.hora);
      else if (proximo.salto === 1) frase = 'Cerrado · abre mañana a las ' + comoHora(proximo.hora);
      else frase = 'Cerrado · abre el ' + DIAS[proximo.dia - 1] + ' a las ' + comoHora(proximo.hora);
    }

    texto.textContent = frase;
    caja.hidden = false;
    tarjeta.classList.add(abierta ? 'tmp-local--abierta' : 'tmp-local--cerrada');
    tarjeta.dataset.abierta = abierta ? 'si' : 'no';
    hayEstado = true;
  });

  /* --- Filtros: ciudad y «abiertas ahora». Esconden y muestran, no reordenan. --- */
  var barra = document.querySelector('[data-tmp-locales-filtros]');
  if (!barra) return;
  var seccion = barra.closest('.shopify-section') || document;
  var cuenta = seccion.querySelector('[data-tmp-locales-cuenta]');
  var vacio = seccion.querySelector('[data-tmp-locales-vacio]');
  var soloAbiertas = barra.querySelector('[data-tmp-solo-abiertas]');
  var tarjetas = Array.prototype.slice.call(zona.querySelectorAll('[data-tmp-local]'));
  var ciudad = '';
  var abiertas = false;

  /* El filtro de estado solo existe si se ha podido calcular el estado. */
  if (soloAbiertas && hayEstado) soloAbiertas.hidden = false;

  function pintar() {
    var vistas = 0;
    tarjetas.forEach(function (t) {
      var cabe = (!ciudad || t.dataset.ciudad === ciudad) &&
                 (!abiertas || t.dataset.abierta === 'si');
      t.hidden = !cabe;
      if (cabe) vistas++;
    });
    if (cuenta) cuenta.textContent = vistas + (vistas === 1 ? ' gelatería' : ' gelaterías');
    if (vacio) vacio.hidden = vistas > 0;
    barra.querySelectorAll('[data-tmp-ciudad]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.tmpCiudad === ciudad));
    });
    if (soloAbiertas) soloAbiertas.setAttribute('aria-pressed', String(abiertas));
  }

  barra.addEventListener('click', function (e) {
    var ciudadBtn = e.target.closest('[data-tmp-ciudad]');
    if (ciudadBtn) { ciudad = ciudadBtn.dataset.tmpCiudad; pintar(); return; }
    if (e.target.closest('[data-tmp-solo-abiertas]')) { abiertas = !abiertas; pintar(); }
  });
})();

/* --------------------------------------------------------------------------
   Filtro por sede de la lista de talleres. Una sola pagina: se ven todos o se
   filtra por gelateria.

   Esconde y muestra, no reordena, asi que el orden por estado y fecha se
   mantiene dentro de cada sede. Los rotulos de la cuenta viajan en la barra
   (`data-uno` / `data-varios`) en vez de escritos aqui: el JS de una seccion no
   ve las claves de idioma, y sin eso la cuenta se quedaria en espanol en la
   tienda inglesa.
   -------------------------------------------------------------------------- */
(function () {
  var barra = document.querySelector('[data-tmp-eventos-filtros]');
  if (!barra) return;
  var seccion = barra.closest('.shopify-section') || document;
  var zona = seccion.querySelector('[data-tmp-eventos]');
  if (!zona) return;
  var cuenta = seccion.querySelector('[data-tmp-eventos-cuenta]');
  var vacio = seccion.querySelector('[data-tmp-eventos-vacio]');
  var tarjetas = Array.prototype.slice.call(zona.querySelectorAll('[data-tmp-evento]'));
  var sede = '';

  function pintar() {
    var vistas = 0;
    tarjetas.forEach(function (t) {
      /* Un taller sin sede clasificada sale siempre en «Todos» y nunca
         desaparece de la pagina: lo que no se puede clasificar no se esconde. */
      var cabe = !sede || t.dataset.sede === sede;
      t.hidden = !cabe;
      if (cabe) vistas++;
    });
    if (cuenta) {
      /* El numero viaja como `__n__` y no como `{{ n }}`: Liquid resuelve la
         clave al pintar el atributo, asi que un `{{ n }}` sin valor no llegaria
         entero. Con un centinela propio lo que llega es siempre lo mismo. */
      var molde = vistas === 1 ? barra.dataset.uno : barra.dataset.varios;
      cuenta.textContent = (molde || '__n__').replace('__n__', vistas);
    }
    if (vacio) vacio.hidden = vistas > 0;
    barra.querySelectorAll('[data-tmp-sede]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.tmpSede === sede));
    });
  }

  barra.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-tmp-sede]');
    if (!boton) return;
    sede = boton.dataset.tmpSede;
    pintar();
  });
})();

/* --------------------------------------------------------------------------
   Cantidad en la ficha. Los mismos dos botones que en el carrito, pero aqui
   NO envian el formulario: solo cambian el numero, porque el envio es el
   «Añadir al carrito». Sin JavaScript el campo se escribe a mano.
   -------------------------------------------------------------------------- */
(function () {
  document.querySelectorAll('[data-tmp-cantidad-ficha]').forEach(function (caja) {
    caja.addEventListener('click', function (e) {
      var boton = e.target.closest('[data-tmp-paso]');
      if (!boton) return;
      var campo = caja.querySelector('input[name="quantity"]');
      if (!campo) return;
      var valor = parseInt(campo.value, 10);
      if (isNaN(valor)) valor = 1;
      valor += parseInt(boton.dataset.tmpPaso, 10);
      campo.value = valor < 1 ? 1 : valor;
    });
  });
})();

/* --------------------------------------------------------------------------
   Contador de la galería que se pasa. Las flechas ya las mueve el carrusel de
   arriba (`data-tmp-carrusel`); esto solo dice por cuál vas, que es lo que
   hace que se vea que quedan más.

   El índice NO se calcula dividiendo por el ancho de una pieza: en esta
   galería unas van a doble ancho, así que se busca la primera que todavía
   empieza dentro de la pista.

   El molde del texto viaja en `data-molde` («%1 / %2») en vez de ir escrito
   aquí: el JS del tema no ve las claves de idioma, así que una cadena suelta
   se quedaría en español en la tienda inglesa.
   -------------------------------------------------------------------------- */
(function () {
  document.querySelectorAll('[data-tmp-cuenta]').forEach(function (marca) {
    var caja = marca.closest('[data-tmp-carrusel]');
    var pista = caja && caja.querySelector('[data-tmp-pista]');
    if (!pista) return;
    var piezas = pista.children;
    if (!piezas.length) return;
    var molde = marca.dataset.molde || '%1 / %2';

    function pintar() {
      var n = 1;
      for (var i = 0; i < piezas.length; i++) {
        if (piezas[i].offsetLeft - pista.scrollLeft >= -2) { n = i + 1; break; }
        n = piezas.length;
      }
      // Al final del recorrido se ve mas de una pieza a la vez, asi que la
      // primera que empieza dentro no es la ultima: sin esto el contador se
      // queda en «10 / 11» con la flecha ya apagada, que se lee como que falta
      // una y no se puede llegar.
      if (pista.scrollLeft >= pista.scrollWidth - pista.clientWidth - 2) n = piezas.length;
      marca.textContent = molde.replace('%1', n).replace('%2', piezas.length);
    }
    pista.addEventListener('scroll', pintar, { passive: true });
    addEventListener('resize', pintar);
    pintar();
  });
})();
